<template>
  <div class="container">
    <div class="mask" ref="mask" v-if="isShow"></div>
    <iframe src="https://www.spsspro.com/analysis/index" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      timer: null
    }
  },
  methods: {
    showDom() {
      if (this.timer) return;
      this.timer = setTimeout(() => {
        this.isShow = false
      }, 10000)
    }
  },
  mounted() {
    this.isShow = true
    this.showDom()
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;

  iframe {
    width: 100%;
    height: 100%;
    transform: translateY(-62px);
  }
}

:deep(.dataAnalyst) {
  overflow: hidden;
}

.mask {
  width: 210px;
  height: 210px;
  background: url("../..//assets/image/icon/RightcenterRobot.png");
  background-color: #fff;
  background-size: 100%;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 9.4vh;
  right: 1.25vw;
  z-index: 999999;
}
</style>